import React from 'react';

const ProgressBar = ({ current, total }) => {
  // Divide progress into 4 segments
  const numSegments = 4;
  const stepsPerSegment = total / numSegments;
  
  // Calculate which segment we're in and progress within that segment
  const currentSegment = Math.floor(current / stepsPerSegment);
  const progressInSegment = ((current % stepsPerSegment) / stepsPerSegment) * 100;
  
  return (
    <div className="flex gap-2" data-testid="progress-bar">
      {Array.from({ length: numSegments }).map((_, index) => {
        let fillPercent = 0;
        
        if (index < currentSegment) {
          // Completed segment
          fillPercent = 100;
        } else if (index === currentSegment) {
          // Current segment - show partial fill
          fillPercent = Math.max(progressInSegment, 5); // At least 5% to show progress started
        }
        
        return (
          <div
            key={index}
            className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden"
            data-testid={`progress-segment-${index}`}
          >
            <div
              className="h-full bg-[#2d8a5f] rounded-full transition-all duration-500 ease-out"
              style={{ width: `${fillPercent}%` }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
